import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { constructorName, numberFormat, upperCase } from '../../../../infrastructure/utils';
import { GET_ALL_PAYROLL_COMMUNICATIONS } from './queries';
import { PaymentCommitmentsV } from '../../../components/wallet/PaymentCommitments';

export const PaymentCommitmentsC = () => {
  const [dataCommiments, setDataCommitments] = useState([]);

  const { data: payrollCommunications, loading: loadingPayrollCommunications } = useQuery(
    GET_ALL_PAYROLL_COMMUNICATIONS,
    {
      variables: { onlyWithPaymentDate: true },
      fetchPolicy: 'no-cache',
    }
  );
  useEffect(() => {
    if (payrollCommunications) {
      const data = payrollCommunications?.getAllPayrollCommunicationsTracking?.map((x) => {
        return {
          pctId: x?.pctId,
          client: constructorName([
            x?.payrollCompany?.payrollStaff?.psFirNam,
            x?.payrollCompany?.payrollStaff?.psSecNam,
            x?.payrollCompany?.payrollStaff?.psFirLas,
            x?.payrollCompany?.payrollStaff?.psSecLas,
          ])?.toUpperCase(),
          typeIdentity: x?.payrollCompany?.typeIdentity?.tiPrefix,
          identification: numberFormat(x?.payrollCompany?.pcIdeNum),
          dateCall: x?.pctDate,
          description: upperCase(x?.pctDescription),
          commitmentToPay: x?.pctDatePaymentCommitment,
          typeOfCall: x?.typeOfCall?.tcName?.toUpperCase(),
        };
      });
      setDataCommitments(data);
    }
  }, [payrollCommunications]);

  return (
    <PaymentCommitmentsV
      dataCommiments={dataCommiments}
      loadingPayrollCommunications={loadingPayrollCommunications}
    />
  );
};
